// images and style
import Download from "../assets/download.svg";
import { userStore } from "../store/Store";
import { GenerateCsvDownload } from "../funcs/download/GenerateCsvDownload";

// styles
import "./Components.css";

export default function DownloadCsv(props) {
  const JwtToken = userStore((userDataStore) => userDataStore.JwtToken);
  const handleDownload = () => {
    const controller = new AbortController();
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", "Bearer " + JwtToken);
    const requestOptions = {
      method: "GET",
      headers,
      signal: controller.signal,
    };
    fetch(
      `${process.env.REACT_APP_BACKEND}/pc/${props.endpoint}/${props.id}`,
      requestOptions
    )
      .then((res) => res.json())
      .then((data) => {
        if (data) {
          GenerateCsvDownload(
            data
          );
        } else {
          console.log("no data");
          return;
        }
      })
      .catch((err) => {
        console.log(err);
      });
    return () => controller.abort();
  };

  return (
    <div className="edits">
      <div className="edit-div">
        <img
          src={Download}
          className="edit"
          onClick={handleDownload}
          alt="download"
        />
      </div>
    </div>
  );
}
